import { FormControl, FormGroup } from '@angular/forms';
import { ReportFilterDto } from '../../../../../../../types/dtos/reports.dto';
import { BaseFilterStep } from '../base-filter-step';

export class FilterDeviceStep extends BaseFilterStep {

  public form: FormGroup = new FormGroup({
    statusSelect: new FormControl(),
    modelSelect: new FormControl(),
    search: new FormControl(),
  });


  getStepFilter(): ReportFilterDto {
    const {
      statusSelect,
      modelSelect,
      search
    } = this.form.value;

    return {
      filter: {
        status: statusSelect ?? undefined,
        search: search ?? undefined,
        model_id: modelSelect ? Number(modelSelect) : undefined,
      }
    };
  }

  getForm(): FormGroup {
    return this.form;
  }
}
